"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformImageExtraction = void 0;
const TransformObject_1 = require("./TransformObject");
class TransformImageExtraction extends TransformObject_1.TransformObject {
    constructor(parent, ref, name, data, mimeType) {
        super(parent, { ref, name, data, mimeType }, ref, new Set());
    }
    compile() {
        return {
            ref: this._sharedData.ref,
            name: this._sharedData.name,
            data: this._sharedData.data,
            mimeType: this._sharedData.mimeType,
        };
    }
}
exports.TransformImageExtraction = TransformImageExtraction;
//# sourceMappingURL=TransformImageExtraction.js.map